import {
  ChangeEvent,
  InputHTMLAttributes,
  MouseEventHandler,
  useEffect,
  useState,
} from "react";

export type BasicRadioInputProps = {
  onChange: (value: number) => void;
  onSave: (value: number) => void;
  value: number;
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "type" | "value" | "onMouseUp"
>;

function BasicRangeInput({
  onChange,
  onSave,
  value,
  ...props
}: BasicRadioInputProps) {
  const [v, setV] = useState(value);

  useEffect(() => {
    setV(value);
  }, [value]);

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const v = parseInt(e.target.value);
    if (!isNaN(v)) {
      setV(v);
      onChange(v);
    }
  };

  const onMouseUpHandler: MouseEventHandler = () => {
    onSave(v);
  };

  return (
    <input
      type="range"
      {...props}
      onChange={onChangeHandler}
      value={v}
      onMouseUp={onMouseUpHandler}
    />
  );
}

export default BasicRangeInput;
